module.exports = __webpack_public_path__ + "static/img/lenven-1.4cf714d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lenven/lenven-1.jpg
// module id = 267
// module chunks = 6